import Vue from 'vue';
import axios from 'axios';
import { LOCAL_STORAGE_TOKEN_NAME } from '../constants/adobe';

const PSD_API = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_PS_URL : '/pie/psdService',
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': process.env.VUE_APP_PS_CLIENT_ID,
    'Authorization': 'Bearer ' + localStorage.getItem(LOCAL_STORAGE_TOKEN_NAME),
  }
})

export default Vue.prototype.$photoshop = PSD_API;


